export const isRecentRelease = (releaseDate) => {
    if (!releaseDate) return false;
    const releaseDateObj = new Date(releaseDate);
    const twoWeeksAgo = new Date();
    twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14); // Subtrai 14 dias da data atual
    return releaseDateObj >= twoWeeksAgo;
};